// entry point
import * as React from 'react';
import { createRoot } from 'react-dom/client';

import MakeMainRoutes from './router';
import { initializeOpenReplay } from './utils/openReplay';
import { initPosthog } from './utils/posthog';
import { initSentry } from './utils/sentry';

import './index.css';

initSentry();
initPosthog();
initializeOpenReplay();

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(<MakeMainRoutes />);
